import React, { useEffect, useState, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import "./EUMRVReportSummary.scss";

import { AbsReactTable, Input, TABLE } from "abs-ui-components";

import EUMRV_Report_Summary from "./EUMRVReportSummery.json";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	AGGRIGATION_F_LABELS,
	CCS_CCU_LABELS,
	ENERGY_EMISSION_K_LABELS,
	EUETS_EMISSION_D_LABELS,
	EUMRVEmissionsLabels_b1_to_b9,
	EUMRVEmissionsTable,
	REPORT_SUMMMERY_HEADERS_FIRST_VERSION,
	REPORT_SUMMMERY_HEADERS_SECOND_VERSION,
	ENERGY_FUEL_CONS_C02MRV_LABELS,
	FUELTYPE_REPORT_SUMMMERY_HEADERS_SECOND_VERSION,
} from "../../../../../../constants/ReportSummaryTable_header";
import { getFuelEUMRVReportSummary, getReportSummaryByType, getReportSummeryTable } from "../../../../../../services/ChildReportService";
import ReportSummaryVersion1 from "./ReportSummaryVersion1.json";
import ReportSummaryVersion2 from "./ReportSummaryVersion2.json";
import { roundOff,formatEtsTitle,formatEtsValue } from "../../../../../../services/utilities";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { ClaimType } from "../../../../../../constants/claims";
import { Padding } from "@mui/icons-material";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EUMRVReportSummary = () => {
	const { userHasClaim } = useContext(ClaimsContext);
	const { control, setValue } = useForm();
	const [EUMRVReportSummary, setEumrvReportSummary] = useState([]);
	const [eumrvReportSummaryTable, seteumrvReportSummaryTable] = useState([]);
	const [responseStatus, setResponseStatus] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [fuelEUVersion, setFuelEUVersion] = useState();
	const [fuelEUSecondVersionEmissionsTableData, setFuelEUSecondVersionEmissionsTableData] = useState([]);
	const [fuelEUSecondVersionTotalFuelTypeData, setFuelEUSecondVersionTotalFuelTypeData] = useState([]);
	const [emissionsTotalMT_A, setEmissionsTotalMT_A] = useState([]);
	const TOTAL_FUELS_HEADERS = FUELTYPE_REPORT_SUMMMERY_HEADERS_SECOND_VERSION;
	const [EUMRVEmissionsB, setEUMRVEmissionsB] = useState([]);
	const [EUETSEmissionD, setEUETSEmissionD] = useState([]);
	const [energyEfficiencyEmissionsK, setEnergyEfficiencyEmissionsK] = useState([]);
	const [aggrigationF, setAggrigationF] = useState([]);
	const [EU_CCS_E, setEU_CCS_E] = useState([]);
	const reportDetails = useSelector((state) => state?.reports?.selectedReportDetails);
	const [regularNavigation, setRegularNavigation] = useState([]);
	const [onLadenVoyage, setOnLadenVoyage] = useState([]);
	const [throughIce, setThroughIce] = useState([]);
	const [atAnchorage, setAtAnchorage] = useState([]);
	const [totalTransportWork, setTotalTransportWork] = useState([]);
	const [energyFuelConsTotal_J, setEnergyFuelConsTotal_J] = useState([]);
	const [energyEfficiencyFCJ, setEnergyEfficiencyFCJ] = useState({});
	const [fuelConsFilteredData, setFuelConsFilteredData] = useState([]);
	const [timeAtSea, setTimeAtSea] = useState();
	const [emissions, setEmissions] = useState();
	const [EUETSEmissionVoyagesD, setEUETSEmissionVoyagesD] = useState([]);
	const user = useSelector((state) => state.userInfo.userData);
	const [isCollapsed, setIsCollapsed] = useState(true);
	const [isEUETSCollapsed, setIsEUETSCollapsed] = useState(true);
	const [isDistanceCollapsed, setIsDistanceCollapsed] = useState(true);
	const [isEnergyCollapsed, setIsEnergyCollapsed] = useState(true);
	
	const toggleEUETSCollapse = () => {
		setIsEUETSCollapsed(!isEUETSCollapsed);
	};

	const toggleDistanceCollapse = () => {
		setIsDistanceCollapsed(!isDistanceCollapsed);
	};

	const toggleEnergyCollapse = () => {
		setIsEnergyCollapsed(!isEnergyCollapsed);
	};

	const excludeCategoriesForFuelCons_A = ["fuelConsPerDistance", "fuelConsPerTransport", "fuelConsPerDistanceOnLaden", "fuelConsPerTransportOnLaden"];
	const exclueFuelConsFor_J = ["totalMt", "timeAtSea", "totalInPort", "totalOnLaden"];
	const categoriesToProcessForEUMRVEmissionsB = [
		"totalMt",
		"totalAtSea",
		"totalOnLaden",
		"voyagesBetweenPorts",
		"voyagesFromPorts",
		"voyagesToPorts",
		"withinPortsAtBerth",
		"withinPorts",
	];
	const emissionTypes = [
		"Co2Mrv",
		"Ch4Mrv",
		"N2oMrv",
		"Co2Eq",
		"Co2Ets",
		"Co2EqMrv",
		"Ch4Ets",
		"N2oEts",
		"Co2EqEts",
		"Co2Mrv-MT",
		"Ch4Mrv-MT",
		"N2oMrv-MT",
		"Co2EqMrv-MT",
		"Co2Eq-MT",
		"Co2Mrv-PAX",
		"Ch4Mrv-PAX",
		"N2oMrv-PAX",
		"Co2EqMrv-PAX",
		"Co2Mrv-DWT",
		"Ch4Mrv-DWT",
		"N2oMrv-DWT",
		"Co2EqMrv-DWT",
		"Co2Mrv-M3",
		"Ch4Mrv-M3",
		"N2oMrv-M3",
		"Co2EqMrv-M3",
	];

	const labels = userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) ? ["Calculated", "% Diff", "5% Materiality"] : [];

	const cceEventTypes = ["CCSCo2Mrv", "CCUCo2Mrv", "Co2EqMrv","CCSCo2Ets", "CCUCo2Ets", "Co2EqEts" ];

	const categoriesToProcessForEUETSEmissionsD = [
		"voyagesBetweenPorts",
		"voyagesFromPorts",
		"voyagesToPorts",
		"withinPorts",
		"smallIslands",
		"omr",
		"transnational",
	];

	const categoriesToProcessForAggrigationF = ["pointF1", "certifiedFuels", "geographicScope", "ccuCcs", "ports", "iceClass", "phaseIn"];

	const categoriesToProcessForEnergyEfficiencyEmissionsJ = [
		"fuelConsPerDistance",
		"fuelConsPerTransport",
		"fuelConsPerDistanceOnLaden",
		"fuelConsPerTransportOnLaden",
	];

	const categoriesToProcessForEnergyEfficiencyEmissionsK = [
		"emissionsPerDistance",
		"emissionsPerTransport",
		"emissionsPerDistanceOnLaden",
		"emissionsPerTransportOnLaden",
	];

	const categoriesToProcessFor_CCS_E = ["ccuBetweenPorts", "ccufromPorts", "ccuToPorts", "ccuWithinPorts"];

	const emissionTotalLabels = {
		totalMt: "a.1) Total (MT)",
		totalInPort: "a.3) Total in port (MT)",
		totalOnLaden: "a.4) Voyage - On laden (MT)",
		totalAtSea: "a.2) Total at sea (MT)",
	};

	const transportWorkFields = [
		"TotalTransportWorkMt",
		"TotalTransportWorkM3",
		"TotalTransportWorkDwt",
		"TotalTransportWorkPax",
		"FuelConsPerTransportWorkMt",
		"FuelConsPerTransportWorkM3",
		"FuelConsPerTransportWorkDwt",
		"FuelConsPerTransportWorkPax",
		"Co2EmissionsPerTransportWorkMt",
		"Co2EmissionsPerTransportWorkM3",
		"Co2EmissionsPerTransportWorkDwt",
		"Co2EmissionsPerTransportWorkPax",
		"FuelConsTransportOnLadenMt",
		"FuelConsTransportOnLadenM3",
		"FuelConsTransportOnLadenDwt",
		"FuelConsTransportOnLadenPax",
		"Co2EmissionsPerTransportWorkOnLadenMt",
		"Co2EmissionsPerTransportWorkOnLadenM3",
		"Co2EmissionsPerTransportWorkOnLadenDwt",
		"Co2EmissionsPerTransportWorkOnLadenPax",
	];

	const modifyTotalMTValues = (emissions, excludedCategories) => {
		const totalEmissionsRenamed = Object.entries(emissions)
			.filter(([category]) => !excludedCategories.includes(category)) // Exclude unwanted categories
			.map(([category, values]) => {
				const totalEntry = values.find((entry) => entry.emissionType === "TOTAL");
				if (totalEntry) {
					return {
						emissionType: category, // Use the key as the name
						emissionValue: totalEntry?.emissionValue, // Keep only the relevant value
					};
				}
				return null; // Skip categories with no "TOTAL" entry
			})
			.filter(Boolean); // Remove null values
		return totalEmissionsRenamed;
	};

	function transformEmissions(emissionsObj, categoriesToProcess, emissionTypes) {
		// Only include specific categories
		return categoriesToProcess.map((category) => {
			const emissions = emissionsObj[category];
			const emissionData = emissions.reduce(
				(acc, { emissionType, emissionValue }) => {
					if (emissionTypes.includes(emissionType)) {
						acc[emissionType] = emissionValue;
					}
					return acc;
				},
				{ category }
			);

			return emissionData;
		});
	}

	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed);
	};

	useEffect(() => {}, [fuelConsFilteredData]);

	const fetchEumrvReportSummaryTabledata = async () => {
		try {
			setLoading(true);
			const response = await getFuelEUMRVReportSummary(reportDetails?.ReportMstId);

			if (response) {
				if (response["reportView"] === "2.0") {
					const filteredData = response?.emissions?.totalMt?.filter((x) => ["Calculated", "Difference", "Materiality"].includes(x.emissionType));
					const filteredTimeatSeaData = response?.emissions?.timeAtSea?.filter((_, index) => index >= 1);
					const filteredDistanceTravelledData = response?.emissions?.distanceTravelled?.filter((_, index) => index >= 1);

					const fuelConsFilteredData = {
						totalMt: filteredData,
						timeAtSea: filteredTimeatSeaData,
						distanceTravelled: filteredDistanceTravelledData,
					};

					if (userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY)) {
						setFuelConsFilteredData(fuelConsFilteredData);
					} else {
						setFuelConsFilteredData([]);
					}

					setFuelEUVersion(2);
					setEmissions(response?.emissions);
					setRegularNavigation(response?.emissions?.regularNaigation);
					setOnLadenVoyage(response?.emissions?.onLadenVoyage);
					setThroughIce(response?.emissions?.throughIce);
					setAtAnchorage(response?.emissions?.atAnchorage);
					setTotalTransportWork(response?.emissions?.totalTransportWork);
					setFuelEUSecondVersionEmissionsTableData(
						response?.emissionsSummary?.map((item) => {
							return {
								...item,
								efCo2Mrv: item.efCo2 !== null ? item.efCo2 : item.efCo2Mrv,
								efCh4Mrv: item.efCh4 !== null ? item.efCh4 : item.efCh4Mrv,
								efN2oMrv: item.efN2o !== null ? item.efN2o : item.efN2oMrv,
								co2EqMrv: item.co2Eq !== null ? item.co2Eq : item.co2EqMrv,
							};
						})
					);
					setFuelEUSecondVersionTotalFuelTypeData(
						response?.totalFuels?.map((item) => {
							return {
								...item,
								efCo2Mrv: item.efCo2 !== null ? item.efCo2 : item.efCo2Mrv,
								efCh4Mrv: item.efCh4 !== null ? item.efCh4 : item.efCh4Mrv,
								efN2oMrv: item.efN2o !== null ? item.efN2o : item.efN2oMrv,
								co2EqMrv: item.co2Eq !== null ? item.co2Eq : item.co2EqMrv,
							};
						})
					);
					const fuelCons_A_Result = modifyTotalMTValues(response?.emissions, excludeCategoriesForFuelCons_A);
					setEmissionsTotalMT_A(fuelCons_A_Result);
					const fuelCons_J_Result = modifyTotalMTValues(response?.emissions, exclueFuelConsFor_J);
					setEnergyFuelConsTotal_J(fuelCons_J_Result);
					const EUMRVEmissions_B_Result = transformEmissions(response?.emissions, categoriesToProcessForEUMRVEmissionsB, emissionTypes);
					setEUMRVEmissionsB(EUMRVEmissions_B_Result);

					const EUETS_D_Result = transformEmissions(
						response?.emissions,
						categoriesToProcessForEUETSEmissionsD.slice(4, categoriesToProcessForEUETSEmissionsD.length),
						emissionTypes
					);
					setEUETSEmissionD(EUETS_D_Result);
					const EUETS_Voyages_D_Result = transformEmissions(
						response?.emissions,
						categoriesToProcessForEUETSEmissionsD.slice(0, 4),
						emissionTypes
					);
					setEUETSEmissionVoyagesD(EUETS_Voyages_D_Result);
					const Energy_EF_K_Result = transformEmissions(response?.emissions, categoriesToProcessForEnergyEfficiencyEmissionsK, emissionTypes);

					const transformedEnergy_EF_K_Result = [];

					Energy_EF_K_Result.forEach((item) => {
						const baseCategory = item.category;
						const mtData = {};
						const paxData = {};
						let hasMTData = false;
						let hasPAXData = false;
						let hasDWTData = false;
						let hasM3Data = false;
						// Check for -MT and -PAX keys
						Object.keys(item).forEach((key) => {
							if (key.endsWith("-MT")) {
								mtData[key.replace("-MT", "")] = item[key];
								hasMTData = true;
							} else if (key.endsWith("-PAX")) {
								paxData[key.replace("-PAX", "")] = item[key];
								hasPAXData = true;
							} else if (key.endsWith("-DWT")) {
								paxData[key.replace("-DWT", "")] = item[key];
								hasDWTData = true;
							} else if (key.endsWith("-M3")) {
								paxData[key.replace("-M3", "")] = item[key];
								hasM3Data = true;
							} else if (key !== "category") {
								// Common keys
								mtData[key] = item[key];
								paxData[key] = item[key];
							}
						});

						if (hasMTData || hasPAXData || hasDWTData || hasM3Data) {
							// Add transformed objects if MT or PAX keys are present
							if (hasMTData) {
								mtData.category = `${baseCategory}_MT`;
								transformedEnergy_EF_K_Result.push(mtData);
							}
							if (hasPAXData) {
								paxData.category = `${baseCategory}_PAX`;
								transformedEnergy_EF_K_Result.push(paxData);
							}
							if (hasDWTData) {
								paxData.category = `${baseCategory}_DWT`;
								transformedEnergy_EF_K_Result.push(paxData);
							}
							if (hasM3Data) {
								paxData.category = `${baseCategory}_M3`;
								transformedEnergy_EF_K_Result.push(paxData);
							}
						} else {
							// Keep the original object if no MT or PAX keys
							transformedEnergy_EF_K_Result.push(item);
						}
					});

					const Energy_Efficiency_FC = {};
					categoriesToProcessForEnergyEfficiencyEmissionsJ.forEach((val) => {
						// Check if the response has emissions for the given category
						if (response?.emissions[val]) {
							// Iterate through the array of emissions for this category dynamically
							response.emissions[val].forEach((emission, index) => {
								// Use a dynamic key structure for Energy_Efficiency_FC
								Energy_Efficiency_FC[`${val}_${emission.emissionType}`] = emission.emissionValue;
							});
						}
					});

					setEnergyEfficiencyFCJ(Energy_Efficiency_FC);
					setEnergyEfficiencyEmissionsK(transformedEnergy_EF_K_Result);
					const aggrigation_F_Result = transformEmissions(response.emissions, categoriesToProcessForAggrigationF, emissionTypes);
					setAggrigationF(aggrigation_F_Result);
					const ccs_E_Result = transformEmissions(response?.emissions, categoriesToProcessFor_CCS_E, cceEventTypes);
					setEU_CCS_E(ccs_E_Result);
					setTimeAtSea(response?.emissions?.timeAtSea[0]?.emissionValue);
				} else {
					setFuelEUVersion(1);
				}
				
				seteumrvReportSummaryTable(response?.summary?.data ?? []);
				
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		const fetchEumrvReportSummary = async () => {
			try {
				const eumrvReportSummaryData = await getReportSummaryByType(reportDetails?.ReportMstId);
				const response = eumrvReportSummaryData.data.Data;
				if (response[0]) {
					setResponseStatus(true);
				}
				EUMRV_Report_Summary.forEach((field) => {
					if (response[0][field.name]) {
						setValue(field.name, response[0][field.name]);
					}
					if (response[0][field.accessor_key_1]) {
						setValue(field.accessor_key_1, response[0][field.accessor_key_1]);
					}
					if (response[0][field.accessor_key_2]) {
						setValue(field.accessor_key_2, response[0][field.accessor_key_2]);
					}
					if (response[0][field.accessor_key_3]) {
						setValue(field.accessor_key_3, response[0][field.accessor_key_3]);
					}
				});

				const filteredSummary = EUMRV_Report_Summary.filter((field) => {
					if (transportWorkFields.includes(field.name)) {
						return response[0][field.name] !== "" && response[0][field.name] !== null;
					}
					return true;
				});
				setEumrvReportSummary(filteredSummary);
			} catch (error) {
				console.error(error);
			}
		};

		fetchEumrvReportSummary();
		fetchEumrvReportSummaryTabledata();
	}, [setValue]);

	const renderEumrvReportData = () => {
		return (
			<div>
				{responseStatus
					? EUMRVReportSummary?.map((field, index) => (
							<div key={`eu-mrv-${index}`}>
								<MDBRow className="eumrv-container mt-3">
									<MDBCol className="col-1"></MDBCol>
									<MDBCol className="col-5 pl-0">
										<label>
											<p className={`label-font ${transportWorkFields.includes(field.name) ? "ml-3 pl-3" : "ml-2"}`}>{field?.label}</p>
										</label>
									</MDBCol>
									{!field?.remove && (
										<>
											<MDBCol className="col-2 pl-0">
												<Controller
													name={field?.name}
													control={control}
													autoFocus={false}
													defaultValue={field?.value || ""}
													render={({ field }) => (
														<Input type={field?.type} {...field} autoFocus={false} className="report-input-eumrv" readOnly />
													)}
												/>
											</MDBCol>
										</>
									)}

									{field?.restrict && (
										<>
											<MDBCol className="col-2 pl-0"></MDBCol>
										</>
									)}

									{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
										<>
											{field?.calculated && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_1}
															control={control}
															defaultValue={field?.value || ""}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field?.diff && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_2}
															control={control}
															defaultValue={field?.value || ""}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field?.materiality && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_3}
															control={control}
															defaultValue={field?.value || ""}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
										</>
									)}
								</MDBRow>
							</div>
					  ))
					: EUMRV_Report_Summary?.map((field, index) => (
							<div key={`report-eu-${index}`}>
								<MDBRow className="eumrv-container mt-3">
									<MDBCol className="col-1"></MDBCol>
									<MDBCol className="col-5 pl-0">
										<label>
											<p className="label-font ml-2">{field?.label}</p>
										</label>
									</MDBCol>
									{!field?.remove && (
										<>
											<MDBCol className="col-2 pl-0">
												<Controller
													name={field?.name}
													control={control}
													autoFocus={false}
													defaultValue={field?.value || "0.00"}
													render={({ field }) => (
														<Input type={field?.type} {...field} autoFocus={false} className="report-input-eumrv" readOnly />
													)}
												/>
											</MDBCol>
										</>
									)}
									{field?.restrict && (
										<>
											<MDBCol className="col-2 pl-0"></MDBCol>
										</>
									)}
									{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
										<>
											{field?.calculated && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_1}
															control={control}
															defaultValue={field?.value || "0.00"}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field?.diff && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_2}
															control={control}
															defaultValue={field?.value || "0.00"}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
											{field?.materiality && (
												<>
													<MDBCol className="col-1 pl-0">
														<Controller
															name={field?.accessor_key_3}
															control={control}
															defaultValue={field?.value || "0.00"}
															render={({ field }) => (
																<Input
																	type={field?.type}
																	{...field}
																	autoFocus={false}
																	className="report-input-eumrv"
																	readOnly
																/>
															)}
														/>
													</MDBCol>
												</>
											)}
										</>
									)}
								</MDBRow>
							</div>
					  ))}
			</div>
		);
	};

	const tableHeader =
		fuelEUVersion === 1
			? REPORT_SUMMMERY_HEADERS_FIRST_VERSION
			: [
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(0, 3),
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(3, 4),
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(4, 7),
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(7, 11),
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(11, 18),
					...REPORT_SUMMMERY_HEADERS_SECOND_VERSION?.slice(18),
			  ];

	const columnTotals = useMemo(() => {
		const results = {};

		tableHeader.forEach(col => {
			results[col.accessorKey] = false;
		});
		const data = fuelEUVersion === 1 ? eumrvReportSummaryTable : fuelEUSecondVersionEmissionsTableData;

		data.forEach(row => {
			tableHeader.forEach(col => {
				const value = row[col.accessorKey];

				if (col.accessorKey === "fuelNo" ||
					(value !== null &&
					value !== undefined &&
					value !== "")
				) {
					results[col.accessorKey] = true;
				}
			});
		});

		return results;
	}, [fuelEUVersion,eumrvReportSummaryTable,   tableHeader]);

    const totalFuelTypeHeaders = TOTAL_FUELS_HEADERS;

	const columnFuelTypeTotals = useMemo(() => {
		const results = {};

		totalFuelTypeHeaders.forEach(col => {
			// if (col.enableTotal) {
			results[col.accessorKey] = false;
			// }
		});

		fuelEUSecondVersionTotalFuelTypeData.forEach(row => {
			totalFuelTypeHeaders.forEach(col => {
				const value = row[col.accessorKey];

				if (col.accessorKey === "fuelNo" ||
					(value !== null &&
						value !== undefined &&
						value !== "")
				) {
					results[col.accessorKey] = true;
				}
			});
		});

		return results;
	}, [fuelEUSecondVersionTotalFuelTypeData, totalFuelTypeHeaders]);

	return (
		<>
			{fuelEUVersion === 1 ? (
				<div>
					<CustomTable
						columnsData={tableHeader
								.filter(col => {
									return columnTotals[col.accessorKey];
								})}
						renderTableData={eumrvReportSummaryTable}
						customProps={{
							enableSort: false,
							isLoading: isLoading,
							header: "Emissions",
						}}
					/>
					<form>
						<MDBRow className="mt-3 eu-label-container">
							<MDBCol className="col-6 pl-0"></MDBCol>
							<MDBCol className="col-2 label-font ml-1">Reported</MDBCol>
							{userHasClaim(ClaimType.VIEW_CALCULATED_DIFF_MATERIALITY) && (
								<>
									<MDBCol className="label-font col-1 ml-1">Calculated</MDBCol>
									<MDBCol className="label-font col-1 ml-1">% Diff</MDBCol>
									<MDBCol className="label-font col-1 ml-1">5% Materiality</MDBCol>
								</>
							)}
						</MDBRow>
						{renderEumrvReportData()}
					</form>
				</div>
			) : (
				<div>
						<CustomTable
							columnsData={tableHeader
								.filter(col => {
									return columnTotals[col.accessorKey];
								})}
							renderTableData={fuelEUSecondVersionEmissionsTableData}
							customProps={{
								enableSort: false,
								isLoading: isLoading,
								header: "Emissions",
								// columnOrder:["fuelNo","fuelIdkey","fuelType","efCo2","efCh4","efN2o","differentiatingCriteria","fuelConsumption","mnc","co2Mrv","ch4Mrv","n2oMrv","co2Eq"]
							}}
						/>
					<div className="mt-4"></div>
					<CustomTable
						columnsData={totalFuelTypeHeaders
								.filter(col => {
									return columnFuelTypeTotals[col.accessorKey];
								})}
						renderTableData={fuelEUSecondVersionTotalFuelTypeData}
						customProps={{
							enableSort: false,
							isLoading: isLoading,
							header: "Totals per Fuel Type",
							// columnOrder:["fuelNo","XfuelIdkey","fuelType","efCo2","efCh4","efN2o","differentiatingCriteria","fuelConsumption","mnc","co2Mrv","ch4Mrv","n2oMrv","co2Eq"]
						}}
					/>

					<div className="total_fuel_consumption_container">
						{/* Header Section */}
						<div onClick={toggleCollapse}>
							<MDBRow
								className="eumrv-container mt-3"
								style={{
									backgroundColor: "#012c51",
									color: "white",
									cursor: "pointer",
									textTransform: "uppercase",
								}}
							>
								<MDBCol size="3">
									<label className="">
										<p className="label-font font-weight-bold m-0 p-0">
											{" "}
											{!isCollapsed ? "+" : "-"}
											<span className="ml-1 ">EU MRV</span>{" "}
										</p>
									</label>
								</MDBCol>
							</MDBRow>
						</div>

						{/* Collapsible Content */}
						{isCollapsed && (
							<>
								{/* a) Fuel Consumptions */}
								<div>
									<MDBRow className="eumrv-container">
										<MDBCol
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-1">{"a) Fuel Consumptions"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3"></MDBCol>
												{labels.map((label, index) => (
													<MDBCol size="3" key={index}>
														<label>
															<p className="label-font ml-2">{label}</p>
														</label>
													</MDBCol>
												))}
											</MDBRow>
										</MDBCol>
									</MDBRow>

									<div style={{ paddingLeft: "25px" }}>
										{emissionsTotalMT_A?.map((field, index) => (
											<div key={`eu-mrv-${index}`}>
												<MDBRow className="eumrv-container mt-2">
													<MDBCol className="col-2 pl-20" size="5">
														<label>
															<p className="label-font ml-2">{emissionTotalLabels && emissionTotalLabels[field?.emissionType]}</p>
														</label>
													</MDBCol>

													<MDBCol className="col-2 pl-0" size="7">
														<MDBRow>
															<MDBCol size="3">
																<Input
																	type="text"
																	value={roundOff(field?.emissionValue || 0, 3, 3)}
																	autoFocus={false}
																	className="report-input-eumrv ml-2"
																	readOnly
																	title={field?.emissionValue || 0}
																/>
															</MDBCol>
															{index === 0 &&
																fuelConsFilteredData?.totalMt?.map((data, idx) => (
																	<MDBCol size="3" key={`fuel-data-${idx}`}>
																		<Input
																			type="text"
																			value={roundOff(data?.emissionValue || 0, 3, 3)}
																			autoFocus={false}
																			className="report-input-eumrv ml-2"
																			readOnly
																			title={data?.emissionValue || 0}
																		/>
																	</MDBCol>
																))}
														</MDBRow>
													</MDBCol>
												</MDBRow>
											</div>
										))}
									</div>
								</div>

								{/* b) Emissions */}
								<div className="eumrv_emissions_container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{"b) Emissions"}</p>
											</label>
										</MDBCol>

										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">CO2 MRV</p>
													</label>
												</MDBCol>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">CH4 MRV</p>
													</label>
												</MDBCol>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">N2O MRV</p>
													</label>
												</MDBCol>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2eq</sub> MRV
														</p>
													</label>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{EUMRVEmissionsB &&
										EUMRVEmissionsB.map((emission, index) => (
											<MDBRow
												className="eumrv-container mt-3"
												key={emission?.category + index}
												style={{
													marginBottom: "1rem",
													paddingLeft: "25px",
												}}
											>
												<MDBCol size="5">
													<label>
														<p className="label-font ml-2">
															{EUMRVEmissionsLabels_b1_to_b9 && EUMRVEmissionsLabels_b1_to_b9[emission?.category]}
														</p>
													</label>
												</MDBCol>
												<MDBCol size="7">
													<MDBRow>
														<MDBCol size="3">
															<Input
																type="text"
																value={roundOff(emission?.Co2Mrv || 0, 3, 3)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={emission?.Co2Mrv || 0}
															/>
														</MDBCol>
														<MDBCol size="3">
															<Input
																type="text"
																value={roundOff(emission?.Ch4Mrv || 0, 3, 3)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={emission?.Ch4Mrv || 0}
															/>
														</MDBCol>
														<MDBCol size="3">
															<Input
																type="text"
																value={roundOff(emission?.N2oMrv || 0, 3, 3)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={emission?.N2oMrv || 0}
															/>
														</MDBCol>
														<MDBCol size="3">
															<Input
																type="text"
																value={roundOff(emission?.Co2EqMrv || 0, 3, 3)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={emission?.Co2EqMrv || 0}
															/>
														</MDBCol>
													</MDBRow>
												</MDBCol>
											</MDBRow>
										))}
								</div>
							</>
						)}
					</div>

					<div className="EU_ETS_container">
						{/* Header Section */}
						<div onClick={toggleEUETSCollapse}>
							<MDBRow
								className="eumrv-container mt-3"
								style={{
									backgroundColor: "#012c51",
									color: "white",
									cursor: "pointer",
									textTransform: "uppercase",
								}}
							>
								<MDBCol size="3">
									<label>
										<p
											className="label-font font-weight-bold m-0 p-0"
											style={{
												cursor: "pointer",
											}}
										>
											{isEUETSCollapsed ? "−" : "+"} EU-ETS
										</p>
									</label>
								</MDBCol>
							</MDBRow>
						</div>

						{/* Collapsible Content */}
						{isEUETSCollapsed && (
							<>
								{/* c) Fuel Consumption */}
								<MDBRow className="eumrv-container mt-1">
									<MDBCol
										style={{
											paddingLeft: "20px",
											fontSize: "13px",
										}}
									>
										<label>
											<p className="label-font font-weight-bold ml-1">{"c) Fuel Consumption"}</p>
										</label>
									</MDBCol>
									<MDBCol size="7">
										<MDBRow>
											<MDBCol size="3"></MDBCol>
											{labels.map((label, index) => (
												<MDBCol size="3" key={index}>
													<label>
														<p className="label-font ml-2">{label}</p>
													</label>
												</MDBCol>
											))}
										</MDBRow>
									</MDBCol>
								</MDBRow>

								<MDBRow
									className="eumrv-container mt-3"
									style={{
										marginBottom: "1rem",
										paddingLeft: "25px",
									}}
								>
									<MDBCol size="5">
										<label>
											<p className="label-font ml-2">{"c.1) Total (MT)"}</p>
										</label>
									</MDBCol>
									<MDBCol size="7">
										<MDBRow>
											<MDBCol size="3">
												<Input
													type="text"
													value={roundOff((emissionsTotalMT_A?.length > 0 && emissionsTotalMT_A[0]?.emissionValue) || 0, 3, 3)}
													autoFocus={false}
													className="report-input-eumrv"
													readOnly
													title={(emissionsTotalMT_A?.length > 0 && emissionsTotalMT_A[0]?.emissionValue) || 0}
												/>
											</MDBCol>
											{fuelConsFilteredData?.totalMt?.map((data, idx) => (
												<MDBCol size="3" key={`fuel-data-${idx}`}>
													<Input
														type="text"
														value={roundOff(data?.emissionValue || 0, 3, 3)}
														autoFocus={false}
														className="report-input-eumrv"
														readOnly
														title={data?.emissionValue || 0}
													/>
												</MDBCol>
											))}
										</MDBRow>
									</MDBCol>
								</MDBRow>

								{/* d) Emissions */}
								<div className="EU_ETS_Emissions">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{"d) Emissions"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CH<sub>4</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															N<sub>2</sub>O ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2Eq</sub> ETS
														</p>
													</label>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{/* d.1 Voyage Emissions */}
									{EUETSEmissionVoyagesD &&
										EUETSEmissionVoyagesD.map((emission, index) => (
											<MDBRow
												className="eumrv-container mt-3"
												key={emission?.category + index}
												style={{
													paddingLeft: "20px",
													marginBottom: "1rem",
												}}
											>
												<MDBCol size="5">
													<label>
														<p className="label-font ml-2">
															{EUETS_EMISSION_D_LABELS && EUETS_EMISSION_D_LABELS[emission?.category]}
														</p>
													</label>
												</MDBCol>
												<MDBCol size="7">
													<MDBRow>
														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Ch4Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Ch4Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.N2oEts)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.N2oEts)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2EqEts)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2EqEts)}
															/>
														</MDBCol>
													</MDBRow>
												</MDBCol>
											</MDBRow>
										))}

									{/* d.2 Aggregated Emissions */}
									{EUETSEmissionD &&
										EUETSEmissionD.map((emission, index) => (
											<MDBRow
												className="eumrv-container mt-3"
												key={emission?.category + index}
												style={{
													paddingLeft: "20px",
													marginBottom: "1rem",
												}}
											>
												<MDBCol size="5">
													<label>
														<p className="label-font ml-2">
															{EUETS_EMISSION_D_LABELS && EUETS_EMISSION_D_LABELS[emission?.category]}
														</p>
													</label>
												</MDBCol>

												<MDBCol size="7">
													<MDBRow>
														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Ch4Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Ch4Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.N2oEts)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.N2oEts)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2EqEts)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2EqEts)}
															/>
														</MDBCol>
													</MDBRow>
												</MDBCol>
											</MDBRow>
										))}
								</div>

								{/* e) CCS & CCU */}
								<div className="EU_ETS_E_container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{"e) CCS (Article 12.3a) and CCU (Article 12.3b)"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CCS CO<sub>2</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CCU CO<sub>2</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2eq</sub> ETS
														</p>
													</label>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{EU_CCS_E &&
										EU_CCS_E.map((emission, index) => (
											<MDBRow
												className="eumrv-container mt-3"
												key={emission?.category + index}
												style={{
													paddingLeft: "20px",
													marginBottom: "1rem",
												}}
											>
												<MDBCol size="5">
													<label>
														<p className="label-font ml-2">{CCS_CCU_LABELS && CCS_CCU_LABELS[emission?.category]}</p>
													</label>
												</MDBCol>
												<MDBCol size="7">
													<MDBRow>
														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.CCSCo2Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																//title={emission?.CCSCo2Ets || 0}
																title={formatEtsTitle(emission?.CCSCo2Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.CCUCo2Ets)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.CCUCo2Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2EqEts)}
																autoFocus={false}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2EqEts)}
															/>
														</MDBCol>
													</MDBRow>
												</MDBCol>
											</MDBRow>
										))}
								</div>

								{/* f) Aggregations */}
								<div className="EUETS-Aggrigation-container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">
													{"f) Aggregations as determined according to Part C, Annex II to Regulation (EU) 2015/757"}
												</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow className="mt-3">
												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CH<sub>4</sub> ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															N<sub>2</sub>O ETS
														</p>
													</label>
												</MDBCol>

												<MDBCol size="3">
													<label>
														<p className="label-font ml-2">
															CO<sub>2eq</sub> ETS
														</p>
													</label>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{aggrigationF &&
										aggrigationF.map((emission, index) => (
											<MDBRow
												className="eumrv-container mt-3"
												key={emission?.category + index}
												style={{
													paddingLeft: "20px",
													marginBottom: "1rem",
												}}
											>
												<MDBCol size="5">
													<label>
														<p className="label-font ml-2">{AGGRIGATION_F_LABELS && AGGRIGATION_F_LABELS[emission?.category]}</p>
													</label>
												</MDBCol>
												<MDBCol size="7">
													<MDBRow>
														<MDBCol size="3">
															<Input
																type="text"
																//value={roundOff(emission?.Co2Ets || 0, 3, 3)}
																value={formatEtsValue(emission?.Co2Ets)}
																className="report-input-eumrv"
																readOnly
																autoFocus={false}
																title={formatEtsTitle(emission?.Co2Ets)}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Ch4Ets)}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Ch4Ets)}
																autoFocus={false}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.N2oEts)}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.N2oEts)}
																autoFocus={false}
															/>
														</MDBCol>

														<MDBCol size="3">
															<Input
																type="text"
																value={formatEtsValue(emission?.Co2EqEts)}
																className="report-input-eumrv"
																readOnly
																title={formatEtsTitle(emission?.Co2EqEts)}
																autoFocus={false}
															/>
														</MDBCol>
													</MDBRow>
												</MDBCol>
											</MDBRow>
										))}
								</div>
							</>
						)}
					</div>

					<div className="distance-time-transport-container">
						<div onClick={toggleDistanceCollapse}>
							<MDBRow
								className="eumrv-container mt-3"
								style={{
									backgroundColor: "#012c51",
									color: "white",
									cursor: "pointer",
									textTransform: "uppercase",
									alignItems: "center",
								}}
							>
								<MDBCol size="5" style={{ display: "flex", alignItems: "center" }}>
									<label style={{ display: "flex", alignItems: "center" }}>
										<span
											style={{
												marginRight: "5px",
											}}
										>
											{isDistanceCollapsed ? "−" : "+"}
										</span>
										<p className="label-font font-weight-bold m-0 p-0">Distance, time and transport work</p>
									</label>
								</MDBCol>
							</MDBRow>
						</div>

						{isDistanceCollapsed && (
							<>
								{/* ---------- g) Distance Travelled ---------- */}
								<MDBRow className="eumrv-container mt-1">
									<MDBCol
										size="5"
										style={{
											paddingLeft: "20px",
											fontSize: "13px",
										}}
									>
										<label>
											<p className="label-font font-weight-bold ml-2">{"g) Distance Travelled (nm)"}</p>
										</label>
									</MDBCol>

									<MDBCol size="7" style={{ paddingLeft: "25px" }}>
										<MDBRow>
											<MDBCol size="3">
												<Input
													type="text"
													value={roundOff(
														(emissions?.distanceTravelled?.length > 0 && emissions?.distanceTravelled[0]?.emissionValue) || 0,
														3,
														3
													)}
													className="report-input-eumrv"
													readOnly
													autoFocus={false}
												/>
											</MDBCol>
											{fuelConsFilteredData?.distanceTravelled?.map((data, idx) => (
												<MDBCol size="3" key={`fuel-data-${idx}`}>
													<Input
														type="text"
														value={roundOff(data?.emissionValue || 0, 3, 3)}
														className="report-input-eumrv"
														readOnly
														autoFocus={false}
													/>
												</MDBCol>
											))}
										</MDBRow>
									</MDBCol>
								</MDBRow>

								{/* g.1 Regular navigation */}
								<MDBRow className="eumrv-container mt-3" style={{ paddingLeft: "20px" }}>
									<MDBCol size="5">
										<label>
											<p className="label-font ml-2">{"g.1) Regular navigation (nm)"}</p>
										</label>
									</MDBCol>
									<MDBCol size="7">
										<MDBRow>
											<MDBCol size="3">
												<Input
													type="text"
													value={roundOff((regularNavigation?.length > 0 && regularNavigation[0]?.emissionValue) || 0, 3, 3)}
													className="report-input-eumrv"
													readOnly
													autoFocus={false}
												/>
											</MDBCol>
										</MDBRow>
									</MDBCol>
								</MDBRow>

								{/* g.2 On laden voyage */}
								<MDBRow className="eumrv-container mt-3" style={{ paddingLeft: "20px" }}>
									<MDBCol size="5">
										<label>
											<p className="label-font ml-2">{"g.2) Voyage - On laden (nm)"}</p>
										</label>
									</MDBCol>
									<MDBCol size="7">
										<MDBRow>
											<MDBCol size="3">
												<Input
													type="text"
													value={roundOff((onLadenVoyage?.length > 0 && onLadenVoyage[0]?.emissionValue) || 0, 3, 3)}
													className="report-input-eumrv"
													readOnly
													autoFocus={false}
												/>
											</MDBCol>
										</MDBRow>
									</MDBCol>
								</MDBRow>

								{/* g.3 Through ice */}
								<MDBRow className="eumrv-container mt-3" style={{ paddingLeft: "20px" }}>
									<MDBCol size="5">
										<label>
											<p className="label-font ml-2">{"g.3) Through ice (nm)"}</p>
										</label>
									</MDBCol>
									<MDBCol size="7">
										<MDBRow>
											<MDBCol size="3">
												<Input
													type="text"
													value={roundOff((throughIce?.length > 0 && throughIce[0]?.emissionValue) || 0, 3, 3)}
													className="report-input-eumrv"
													readOnly
													autoFocus={false}
												/>
											</MDBCol>
										</MDBRow>
									</MDBCol>
								</MDBRow>

								{/* ---------- h) Time at sea ---------- */}
								<div className="h-container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{"h) Time at sea (h)"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7" style={{ paddingLeft: "25px" }}>
											<MDBRow>
												<MDBCol size="3">
													<Input type="text" value={roundOff(timeAtSea || 0, 3, 3)} 
													autoFocus={false}
													className="report-input-eumrv" readOnly />
												</MDBCol>

												{fuelConsFilteredData?.timeAtSea?.map((data, idx) => (
													<MDBCol size="3" key={`fuel-data-${idx}`}>
														<Input
															type="text"
															value={roundOff(data?.emissionValue || 0, 3, 3)}
															className="report-input-eumrv"
															readOnly
															autoFocus={false}
														/>
													</MDBCol>
												))}
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{/* h.1 Regular Navigation */}
									<MDBRow className="eumrv-container mt-2" style={{ paddingLeft: "20px" }}>
										<MDBCol size="5">
											<label>
												<p className="label-font ml-2">{"h.1) Regular Navigation (h)"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<Input
														type="text"
														value={roundOff((regularNavigation?.length > 1 && regularNavigation[1]?.emissionValue) || 0, 3, 3)}
														className="report-input-eumrv"
														readOnly
														autoFocus={false}
													/>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{/* h.2 At anchorage */}
									<MDBRow className="eumrv-container mt-2" style={{ paddingLeft: "20px" }}>
										<MDBCol size="5">
											<label>
												<p className="label-font ml-2">{"h.2) At anchorage (h)"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<Input
														type="text"
														value={roundOff((atAnchorage?.length > 0 && atAnchorage[0]?.emissionValue) || 0, 3, 3)}
														className="report-input-eumrv"
														readOnly
														autoFocus={false}
													/>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{/* h.3 Through ice */}
									<MDBRow className="eumrv-container mt-3" style={{ paddingLeft: "20px" }}>
										<MDBCol size="5">
											<label>
												<p className="label-font ml-2">{"h.3) Through ice (h)"}</p>
											</label>
										</MDBCol>
										<MDBCol size="7">
											<MDBRow>
												<MDBCol size="3">
													<Input
														type="text"
														value={roundOff((throughIce?.length > 1 && throughIce[1]?.emissionValue) || 0, 3, 3)}
														className="report-input-eumrv"
														readOnly
														autoFocus={false}
													/>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>
								</div>

								{/* ---------- i) Total transport work ---------- */}
								<div className="i-container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											size="5"
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{`i) Total transport work (${totalTransportWork[0]?.emissionType}*nm)`}</p>
											</label>
										</MDBCol>
										<MDBCol size="7" style={{ paddingLeft: "25px" }}>
											<MDBRow>
												<MDBCol size="3">
													<Input
														type="text"
														value={roundOff((totalTransportWork?.length > 0 && totalTransportWork[0]?.emissionValue) || 0, 3, 3)}
														className="report-input-eumrv"
														readOnly
														autoFocus={false}
													/>
												</MDBCol>
											</MDBRow>
										</MDBCol>
									</MDBRow>

									{totalTransportWork?.length > 1 && (
										<MDBRow className="eumrv-container mt-1">
											<MDBCol
												size="5"
												style={{
													paddingLeft: "20px",
													fontSize: "13px",
												}}
											>
												<label>
													<p className="label-font font-weight-bold ml-2">
														{`i) Total transport work (${totalTransportWork[1]?.emissionType}*nm)`}
													</p>
												</label>
											</MDBCol>
											<MDBCol size="7" style={{ paddingLeft: "25px" }}>
												<MDBRow>
													<MDBCol size="3">
														<Input
															type="text"
															value={roundOff(
																(totalTransportWork?.length > 0 && totalTransportWork[1]?.emissionValue) || 0,
																3,
																3
															)}
															className="report-input-eumrv"
															readOnly
															autoFocus={false}
														/>
													</MDBCol>
												</MDBRow>
											</MDBCol>
										</MDBRow>
									)}
								</div>
							</>
						)}
					</div>

					<div className="energy-efficiency-container">
						<div onClick={toggleEnergyCollapse}>
							<MDBRow
								className="eumrv-container mt-3"
								style={{
									backgroundColor: "#012c51",
									color: "white",
									cursor: "pointer",
									textTransform: "uppercase",
									alignItems: "center",
								}}
							>
								<MDBCol size="3" style={{ display: "flex", alignItems: "center" }}>
									<label style={{ display: "flex", alignItems: "center" }}>
										<span
											style={{
												marginRight: "5px",
											}}
										>
											{isEnergyCollapsed ? "−" : "+"}
										</span>
										<p className="label-font font-weight-bold m-0 p-0">Energy Efficiency</p>
									</label>
								</MDBCol>
							</MDBRow>
						</div>

						{isEnergyCollapsed && (
							<>
								<div className="j-container">
									<MDBRow className="eumrv-container mt-1">
										<MDBCol
											style={{
												paddingLeft: "20px",
												fontSize: "13px",
											}}
										>
											<label>
												<p className="label-font font-weight-bold ml-2">{"j) Fuel consumption"}</p>
											</label>
										</MDBCol>
									</MDBRow>

									{Object.keys(energyEfficiencyFCJ)?.map((FC_Key, ind) => (
										<MDBRow
											key={FC_Key}
											className="eumrv-container mt-2"
											style={{
												paddingLeft: "20px",
												marginBottom: "1rem",
											}}
										>
											<MDBCol size="5">
												<label>
													<p className="label-font ml-2">
														{`j.${ind + 1}) `}
														{ENERGY_FUEL_CONS_C02MRV_LABELS && ENERGY_FUEL_CONS_C02MRV_LABELS[FC_Key]}
													</p>
												</label>
											</MDBCol>
											<MDBCol size="7">
												<MDBRow>
													<MDBCol size="3">
														<Input
															type="text"
															value={roundOff((energyEfficiencyFCJ && energyEfficiencyFCJ[FC_Key]) || 0, 3, 3)}
															className="report-input-eumrv"
															readOnly
															autoFocus={false}
															title={(energyEfficiencyFCJ && energyEfficiencyFCJ[FC_Key]) || 0}
														/>
													</MDBCol>
												</MDBRow>
											</MDBCol>
										</MDBRow>
									))}
								</div>
								
									<div className="Enegry-k-container">
										<MDBRow className="eumrv-container mt-1">
											<MDBCol style={{ paddingLeft: "20px", fontSize: "13px" }}>
												<label>
													<p className="label-font font-weight-bold ml-2">k) Emissions</p>
												</label>
											</MDBCol>
											<MDBCol size="7">
												<MDBRow>
													{["CO2 MRV", "CH4 MRV", "N2O MRV", "CO2 EqMRV"].map((label, idx) => (
														<MDBCol key={idx} size="3">
															<label>
																<p className="label-font ml-2">
																	{label === "CO2 EqMRV" ? (
																		<>
																			<p className="label-font ml-2">
														                	 CO<sub>2eq</sub> MRV
													                     	</p>
																		</>
																	) : (
																		label
																	)}
																</p>
															</label>
														</MDBCol>
													))}
												</MDBRow>
											</MDBCol>
										</MDBRow>

										{energyEfficiencyEmissionsK &&
											energyEfficiencyEmissionsK.map((emission, index) => (
												<MDBRow
													className="eumrv-container mt-3"
													key={emission?.category + index}
													style={{ paddingLeft: "20px", marginBottom: "1rem" }}
												>
													<MDBCol size="5">
														<label>
															<p className="label-font ml-2">
																{`k.${index + 1}) `}
																{ENERGY_EMISSION_K_LABELS && ENERGY_EMISSION_K_LABELS[emission?.category]}
															</p>
														</label>
													</MDBCol>

													<MDBCol size="7">
														<MDBRow>
															{["Co2Mrv", "Ch4Mrv", "N2oMrv", "Co2EqMrv"].map((key, idx) => (
																<MDBCol key={idx} size="3">
																	<Input
																		type="text"
																		value={roundOff(emission?.[key] || 0, 3, 3)}
																		autoFocus={false}
																		className="report-input-eumrv"
																		readOnly
																		title={emission?.[key] || 0}
																	/>
																</MDBCol>
															))}
														</MDBRow>
													</MDBCol>
												</MDBRow>
											))}
									</div>								
							</>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default EUMRVReportSummary;
